import { QueryParams } from 'APIs/types';
import { DateFilterQueryInput, DateFilterValue, toLocalDateFilterInput } from 'Components/Common/Filters/DateFilter';
import { MultiSelectFilterValue } from 'Components/Common/Filters/MultiSelectFilter';
import { FilterOption } from 'Components/Common/Filters/types';
import { invoiceStatuses } from 'Constants/Constants';

export const initFilterOptions: FilterOption[] = [
  {
    option_id: 'createdOn',
    checked: false,
    value: null,
    label: 'Issued on',
    optionType: 'date',
    optionConfig: {
      conditions: ['is_in_the_last', 'is_equal_to', 'is_between', 'is_after', 'is_before'],
    },
  },
  {
    option_id: 'status',
    checked: true,
    value: ['outstanding', 'overdue'],
    label: 'Status',
    optionType: 'multi_select',
    optionConfig: {
      options: invoiceStatuses,
    },
  },
];

export const filterQueryParams = (filterOptionValues: FilterOption[]): QueryParams => {
  return filterOptionValues.reduce((acc: QueryParams, option) => {
    if (option.checked && option.value !== null) {
      if (option.option_id === 'createdOn') {
        const dateValue: DateFilterQueryInput | null = toLocalDateFilterInput(option.value as DateFilterValue);

        if (dateValue) {
          if ('gt' in dateValue) {
            acc['issuedOnFromInclusive'] = dateValue.gt as string;
          }
          if ('gte' in dateValue) {
            acc['issuedOnFromInclusive'] = dateValue.gte as string;
          }
          if ('lt' in dateValue) {
            acc['issuedOnToInclusive'] = dateValue.lt as string;
          }
          if ('lte' in dateValue) {
            acc['issuedOnToInclusive'] = dateValue.lte as string;
          }
        }
      }
      if (option.option_id === 'status') {
        const value = option.value as MultiSelectFilterValue;
        acc['status'] = value?.join(',') as string;
      }
    }
    return acc;
  }, {});
};
